<div class="contato-container">
  <div *ngFor="let company of contatos?.companies" class="empresa-container">
    <div class="info-empresa d-flex">
      <div class="empresa col-9">
        <img
          [src]="
            company.companyLogoUrl
              ? company.companyLogoUrl
              : BASE_IMG_URL +
                'assets/img-ficha-obra/placeholder.png'
          "
          width="80"
          height="80"
          alt="Logo da empresa"
        />

        <div class="title-empresa">
          <p class="nome-company">
            {{ company.companyTradeName }}
            <span class="role-badge">{{ company.companyRoleAlias }}</span>
          </p>
          <div class="total-obras">
            <p><strong>CNPJ: </strong>{{ company.companyCNPJ }}</p>
            <p>
              <strong>Total de obras: </strong>{{ company.companyTotalWorks }}
            </p>
          </div>
        </div>
      </div>
      <div class="contatos-empresa d-flex flex-column align-items-start">
        <div class="d-flex align-items-center company">
          <span
            class="status-dot"
            [ngStyle]="{
              'background-color': getStatusDotColor(company.companyPhone1Color)
            }"
            [ngClass]="company.companyPhone1Color"
          ></span>
          <i class="bi bi-wpp me-1"></i>
          <span class="tel-empresa">{{ company.companyPhone1 }}</span>
        </div>
        <div class="d-flex align-items-center" *ngIf="company.companyPhone2">
          <span
            class="status-dot"
            [ngStyle]="{
              'background-color': getStatusDotColor(company.companyPhone2Color)
            }"
            [ngClass]="company.companyPhone2Color"
          ></span>
          <i class="bi bi-wpp me-1"></i>
          <span class="tel-empresa">{{ company.companyPhone2 }}</span>
        </div>
        <div class="btn-redes d-flex">
          <button
            class="btn btn-link"
            type="button"
            title="Whatsapp"
            [disabled]="!company.companyWhatsapp"
          >
            <a
              [href]="getWhatsappLink(company.companyWhatsapp)"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="{{
                  BASE_IMG_URL
                }}assets/img-ficha-obra/icone-whatsapp.png"
                alt="WhatsApp"
                width="24"
                height="24"
              />
            </a>
          </button>
          <button
            class="btn btn-link"
            type="button"
            title="Linkedin"
            [disabled]="!company.companyLinkedinUrl"
          >
            <a
              [href]="company.companyLinkedinUrl"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="{{
                  BASE_IMG_URL
                }}assets/img-ficha-obra/icone-linkedin-24.png"
                alt="LinkedIn"
                width="24"
                height="24"
              />
            </a>
          </button>
          <button
            class="btn btn-link"
            type="button"
            title="Youtube"
            [disabled]="!company.companyYoutubeUrl"
          >
            <a
             [href]="getExternalUrl(company.companyYoutubeUrl)" 
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="{{
                  BASE_IMG_URL
                }}assets/img-ficha-obra/icone-youtube.png"
                alt="YouTube"
                width="24"
                height="24"
              />
            </a>
          </button>
          <button
            class="btn btn-link"
            type="button"
            title="Site"
            [disabled]="!company.companyWebsite"
          >
            <a
              [href]="
                company.companyWebsite &&
                company.companyWebsite.startsWith('http')
                  ? company.companyWebsite
                  : 'http://' + company.companyWebsite
              "
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="{{
                  BASE_IMG_URL
                }}assets/img-ficha-obra/icone-website.png"
                alt="Website"
                width="24"
                height="24"
              />
            </a>
          </button>
        </div>
      </div>
    </div>

    <div *ngFor="let contato of company.contacts" class="contato">
      <div class="report-contato">
        <div>
          <p class="titulo-comprador mb-0">
        {{ contato.contactRole }}
        <span *ngIf="company.contacts" class="pipe">|</span>
        {{ contato.contactName }}
      </p>
        </div>
         <button
            class="btn btn-link btn-report-contato"
            type="button"
            title="Reportar erro no contato"
            (click)="abrirReportContato(contato, company)"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              width="20"
              height="20"
            >
              <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
              <line x1="12" y1="9" x2="12" y2="13"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
          </button>
      </div>
      
      <div class="infos-contato">
        <ul class="list-email col-9">
          <li *ngIf="contato.contactEmail">
            <span class="status-dot verde me-1"></span>
            <a href="mailto:{{ contato.contactEmail }}">{{
              contato.contactEmail
            }}</a>
          </li>
        </ul>
        <div class="contato-telefone">
          <ul
            class="list-fone"
            *ngIf="contato.contactPhone1 || contato.contactPhone2"
          >
            <li *ngIf="contato.contactPhone1">
              <span
                class="status-dot"
                [ngStyle]="{
                  'background-color': getStatusDotColor(
                    contato.contactPhone1Color
                  )
                }"
                [ngClass]="contato.contactPhone1Color"
              ></span>
              <i class="bi bi-wpp me-2"></i>
              {{ contato.contactPhone1 }}
            </li>
            <li *ngIf="contato.contactPhone2">
              <span
                class="status-dot"
                [ngStyle]="{
                  'background-color': getStatusDotColor(
                    contato.contactPhone2Color
                  )
                }"
                [ngClass]="contato.contactPhone2Color"
              ></span>
              <i class="bi bi-wpp me-2"></i>
              {{ contato.contactPhone2 }}
            </li>
          </ul>
          <div class="btn-redes d-flex">
            <button
              class="btn btn-link"
              title="Agendar Tarefa"
              (click)="abrirAgendarTarefa(contato)"
              type="button"
            >
              <img
                src="{{
                  BASE_IMG_URL
                }}assets/img-ficha-obra/icone-adicionar-tarefa.png"
                alt="Agendar Tarefa"
                width="24"
                height="24"
              />
            </button>
            <button
              class="btn btn-link"
              type="button"
              title="Whatsapp"
              [disabled]="!company.companyWhatsapp"
            >
              <a
                [href]="getWhatsappLink(company.companyWhatsapp)"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="{{
                    BASE_IMG_URL
                  }}assets/img-ficha-obra/icone-whatsapp.png"
                  alt="WhatsApp"
                  width="24"
                  height="24"
                />
              </a>
            </button>
            <button
              class="btn btn-link"
              type="button"
              title="Linkedin"
              [disabled]="!company.companyLinkedin"
            >
              <a
                [href]="company.companyLinkedin"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="{{
                    BASE_IMG_URL
                  }}assets/img-ficha-obra/icone-linkedin-24.png"
                  alt="LinkedIn"
                  width="24"
                  height="24"
                />
              </a>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-side-panel
  [isOpen]="isPanelOpen"
  [title]="panelTitle"
  (close)="closePanel()"
>

  <ng-container *ngIf="currentPanel === 'agendar-tarefa'">
    <app-agendar-tarefa
      [idObra]="idObra"
      (close)="closePanel()"
      [contatoInfo]="contatoSelecionado"
      (tarefaCriada)="atualizarListaTarefas($event)"
      (loading)="onPainelLoading($event)"
    ></app-agendar-tarefa>
  </ng-container>
</app-side-panel>

<app-modal-reportar-erro-contato
  *ngIf="showReportContato && contatoParaReport"
  [contactId]="contatoParaReport?.contactId"
  [contactName]="contatoParaReport?.contactName"
  [contactRole]="contatoParaReport?.contactRole"
  [contactEmail]="contatoParaReport?.contactEmail"
  [contactPhone]="contatoParaReport?.contactPhone1"
  [constructorId]="empresaParaReport?.companyId"
  [constructorName]="empresaParaReport?.companyTradeName"
  [workId]="idObra"
  [workName]="workName"
  [moduleId]="idModulo"
  [module]="moduleName"
  [companyId]="companyId"
  [companyName]="companyName"
  (close)="fecharReportContato()"
  (loading)="onPainelLoading($event)"
></app-modal-reportar-erro-contato>
